module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_8019.0f79615c.png";